import axios from 'axios'

import { environment } from '@/shared/consts/environment'
import { ISart, IValidateCodeRequestData } from 'interfaces'
import './axiosAuthMiddleware'

const apiUrl = `${environment.apiUrl}/api/v1/auth0`
const userApiUrl = `${environment.apiUrl}/api/v1/users`

/**
 * request token
 * */
export const requestAuthenticationCode = async ({ data, type }: ISart) => {
  try {
    if (type.toLowerCase() === 'sms' && data) {
      data = data.replaceAll(' ', '')
    }
    const res = await axios.post(`${apiUrl}/start`, {
      data,
      type,
    })
    return res.data
  } catch (error) {
    new Error(error) // This throw will allow us catch errors on sendgrid service

    return {
      error,
      message: error.response?.data?.message[0] || 'Internal server error',
    }
  }
}
export const requestAuthenticationCodeSignup = async ({
  data,
  type,
}: ISart) => {
  try {
    if (type.toLowerCase() === 'sms' && data) {
      data = data.replaceAll(' ', '')
    }
    const res = await axios.post(`${apiUrl}/start-signup`, {
      data,
      type,
    })
    return res.data
  } catch (error) {
    new Error(error) // This throw will allow us catch errors on sendgrid service

    return {
      error,
      message: error.response?.data?.message[0] || 'Internal server error',
    }
  }
}

/**
 * validate token
 * */
export const validateOTP = async (data: IValidateCodeRequestData) => {
  try {
    const res = await axios.post(`${apiUrl}/accesstoken`, data)
    return res.data
  } catch (error) {
    new Error(error) // This throw will allow us catch errors on sendgrid service

    return {
      error,
    }
  }
}
export const validateSignupOTP = async (data: IValidateCodeRequestData) => {
  try {
    const res = await axios.post(`${apiUrl}/accesstoken-signup`, data)
    return res.data
  } catch (error) {
    new Error(error) // This throw will allow us catch errors on sendgrid service

    return {
      error,
    }
  }
}

/**
 * find user by  email or phone
 * */
export const findUser = async ({
  email,
  phone,
}: {
  email: string
  phone: string
}) => {
  try {
    const res = await axios.post(userApiUrl + '/find-user', {
      email,
      phone,
    })

    return res.data
  } catch (error) {
    new Error(error) // This throw will allow us catch errors on sendgrid service

    return {
      error,
    }
  }
}
